<template>
  <div>
    <!-- 头部 -->
    <div class="headerTop">
      <div class="EC_width display_between height_100">
        <div class="lettLogo">
          <!-- <img src="../../assets/img/mlogo.png" alt="" class="logo"> -->
          <h2>带状疱疹医防融合云学院</h2>
        </div>
        <div class="display_center_ud">
          <div
            class="headerTop_login"
            v-show="AuthorId > 0"
            v-if="authorinfo != null"
          >
            <router-link to="/user/userMymsg">
              <img
                src="/image/index/lingdangset.png"
                alt=""
                class="headerTop_login_img"
              />
              <span class="msgnum" v-show="unreadmsg > 0">{{ unreadmsg }}</span>
            </router-link>
            <div
              @click.capture="taggleinfor = true"
              style="cursor: pointer; position: relative"
            >
              <span style="color: #000">{{ authorinfo.mobile }}</span>
            </div>
            <div class="opra" v-show="taggleinfor" @click.stop="setClick">
              <div class="display_flex">
                <div class="flex1 marginLeft10">
                  <p class="marginTop10 marginBottom10">
                    {{
                      authorinfo.nickname != ""
                        ? authorinfo.nickname
                        : authorinfo.mobile
                    }}
                    <router-link to="/user">
                      <span class="informy" style="cursor: pointer">
                        个人资料
                      </span>
                    </router-link>
                  </p>
                  <p>
                    {{ authorinfo.mobile }}
                  </p>
                </div>
                <div>
                  <span class="out" @click="out">退出</span>
                </div>
              </div>
            </div>
            <div
              class="modal"
              v-if="taggleinfor"
              @click="taggleinfor = false"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header_index',
  data () {
    return {
      currentindex: 0,
      taggleinfor: false,
      loginStaus: false,
      authorinfo: null,
      keywords: '',
      AuthorId: 0,
      isDebug: true,
      isseach: true,
      unreadmsg: 0,
      userType: 0,
      dialogTableVisible: false
    };
  },
  watch: {
    $route (to) {
      if (to.name == 'home') {
        this.AuthorId = localStorage.getItem('userInfo')
          ? JSON.parse(localStorage.getItem('userInfo')).userId
          : 0;
        this.authorinfo = localStorage.getItem('userInfo')
          ? JSON.parse(localStorage.getItem('userInfo'))
          : null;
        this.GetMessageCount();
      }
    }
  },

  created () {
    if (this.$route.name != 'searchPage') {
      this.isseach = true;
    } else {
      this.isseach = false;
    }
  },
  mounted () {
    this.GetMessageCount();
  },
  beforeRouteEnter (to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      if (to.meta.activeNum != undefined) {
        vm.currentindex = to.meta.activeNum;
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    if (to.meta.activeNum != undefined) {
      this.currentindex = to.meta.activeNum;
    }
    next();
  },
  methods: {
    GetMessageCount () {
      if (localStorage.getItem('userInfo')) {
        if (this.$route.meta.activeNum != undefined) {
          this.currentindex = this.$route.meta.activeNum;
        }
        if (this.$cookies.isKey('token_hcp')) {
          const _tokenkey = this.$cookies.get('token_hcp');
          this.httphelper
            .post('HCUserApi/CheckToken', {
              tokenKey: _tokenkey,
              iP_Address: '127.0.0.1',
              login_Device: 'PC'
            })
            .then((res) => {
              if (res.data.code == 200) {
                localStorage.setItem('userInfo', JSON.stringify(res.data.data));
                this.AuthorId = res.data.data.userId;
                this.authorinfo = res.data.data;
                localStorage.setItem('audit_state', res.data.data.audit_state);
                if (res.data.data.audit_state != 9) {
                  this.$router.push({
                    path: '/collect'
                  });
                }
                this.httphelper
                  .get('/HCUserApi/GetMessageCount', {
                    UserId: this.AuthorId
                  })
                  .then((ress) => {
                    if (ress.code == 200) {
                      if (res.data != null) {
                        this.unreadmsg = ress.data;
                      }
                    }
                  });
              } else {
                localStorage.clear();
                this.$cookies.remove('token_hcp');
              }
            });
        } else {
          localStorage.clear();
          this.$cookies.remove('token_hcp');
        }
      } else {
        const url = new URL(window.location.href);
        const prvValue = url.searchParams.get('prv');

        if (prvValue !== null) {
          // console.log('prv 参数存在，值为:', prvValue);
        } else {
          // console.log('prv 参数不存在');
          this.$router.push('/login');
        }
      }
    },
    toHome () {
      this.$router.push({
        path: '/'
      });
    },
    setClick () {},
    tougao (url) {
      this.dialogTableVisible = false;
      window.open(url);
    },
    out () {
      this.taggleinfor = false;
      this.loginStaus = false;
      this.AuthorId = 0;
      this.outClearToken();
    },
    userlogin () {
      const routeUrl = this.$router.resolve({
        path: '/login'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    userRegister () {
      // this.taggleinfor=true
      const routeUrl = this.$router.resolve({
        path: '/login'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    onsearch () {
      this.$router.push({
        name: 'searchPage',
        params: { labelname: this.keywords }
      });
    },
    outClearToken () {
      const _tokenkey = this.$cookies.get('token_hcp');
      this.httphelper
        .post('/HCUserApi/ClearToken', {
          tokenKey: _tokenkey,
          iP_Address: '127.0.0.1',
          login_Device: 'PC'
        })
        .then((res) => {
          if (res.data.code == 200) {
            localStorage.clear();
            this.$cookies.remove('token_hcp');
            location.reload();
          }
        });
    },
    checkToken () {
      const _tokenkey = this.$cookies.get('token_hcp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then((res) => {
          if (res.data.code == 200) {
            localStorage.setItem('userInfo', JSON.stringify(res.data.data));
            return true;
          }
          return false;
        });
    }
  }
};
</script>

<style scoped>
/* 页面的顶部搜索条 */
.headerTop {
  height: 60px;
  background: #fff;
  min-width: 1240px;
}

.headerTop_home {
  color: #fff;
  font-size: 14px;
}

.lettLogo {
  display: flex;
  align-items: center;
}

.logo {
  width: 160px;
  /* height: 56px; */
  margin-right: 90px;
}

.headerTop_search {
  position: relative;
}

.headerTop_search input {
  width: 200px;
  height: 26px;
  outline: none;
  border-radius: 26px;
  box-sizing: border-box;
  padding-left: 20px;
}

.headerTop_search img {
  position: absolute;
  right: 13px;
  top: 4px;
  cursor: pointer;
}

.headerTop_login {
  position: relative;
  display: flex;
}

.headerTop_login a {
  color: #000;
  font-size: 12px;
  cursor: pointer;
}

.headerTop_login_img {
  margin-left: 20px;
  margin-right: 20px;
  vertical-align: -2px;
}

.search {
  width: 280px;
  height: 32px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #f36633;
}

/* 头部样式 */
.header {
  height: 90px;
  display: flex;
  min-width: 1240px;
}

.logoWrap {
  /* width: 340px; */
  width: 280px;
  margin-left: 0px;
}

.menu_item {
  padding: 0 20px;
  line-height: 90px;
  overflow: hidden;
  box-sizing: border-box;
}

.menu_item_style {
  padding: 0 20px;
  line-height: 90px;
  box-sizing: border-box;
}

.menu_item_style a {
  width: 80px;
  height: 34px;
  color: #fff;
  line-height: 34px;
  text-align: center;
  display: inline-block;
  border-radius: 36px;
  background: #b70109;
}

.menu_item a {
  color: #333;
  font-weight: bold;
  white-space: nowrap;
}

.menu_item_active {
  border-bottom: 3px solid #0b8485;
}

.menu_item_active a {
  color: #0b8485;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}

.opra {
  padding: 25px;
  display: inline-block;
  position: absolute;
  background: #fff;
  width: 400px;
  box-sizing: border-box;
  right: 0px;
  top: 29px;
  box-shadow: 0px 5px 15px 0px rgba(6, 50, 52, 0.2);
  border-radius: 3px;
  z-index: 100;
}

.out {
  padding: 2px 8px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  cursor: pointer;
}

.informy {
  width: 77px;
  height: 25px;
  background: #0b8586;
  border-radius: 13px;
  display: inline-block;
  text-align: center;
  line-height: 25px;
  color: #fff;
  margin-left: 5px;
}

.vip {
  height: 50px;
  /* background: url("/image/index/gerenbar.png"); */
  padding: 0 6px;
}

.kaitong {
  width: 96px;
  height: 29px;
  background: linear-gradient(90deg, #ff1e00, #ff6600);
  border-radius: 14px;
  text-align: center;
  line-height: 29px;
  color: #fff;
}

.ArrowTop {
  position: absolute;
  top: -30px;
}

.img-border {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.viplogpo {
  width: 12px;
  height: 12px;
  position: absolute;
  left: 36px;
  top: -2px;
  z-index: 9;
}

.msgnum {
  position: absolute;
  left: 35px;
  top: -5px;
  background-color: rgb(207, 19, 19);
  color: #fff;
  padding: 0px 2px 1px;
  border-radius: 8px;
}

.chaxun ::v-deep .el-dialog {
  width: 503px;
}
</style>
